module.exports = __webpack_public_path__ + "static/img/logo87.c3cca2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo87.png
// module id = S2jm
// module chunks = 1